// deps
import React, { memo } from "react";
import cx from "classnames";

// internal deps
import { Image, useEffectOnce } from "@swiggy-private/core-ui";

// components
import { CartGroupContainer } from "@cart-ui/components/cart-group";

// types
import { RenderingDetails } from "@swiggy-private/cart-types";

// styles
import styles from "./SelfDeliveryInstruction.scss";

// helpers
import { getSelfDeliveryImgURL } from "@cart-ui/helpers/SelfDeliveryInstructions";

export interface SelfDeliveryInstructionProps {
    itemData: RenderingDetails;
    onImpressionSelfDeliveryInstruction: VoidFunction;
    allowTitleWrap?: boolean;
}

const SelfDeliveryInstruction: React.FC<SelfDeliveryInstructionProps> = ({
    itemData,
    onImpressionSelfDeliveryInstruction,
    allowTitleWrap = false,
}: SelfDeliveryInstructionProps) => {
    const { meta: { self_delivery_presentation_info: selfDeliveryInfo } = {} } = itemData;
    const { title, image_id: imgId, subtitle } = selfDeliveryInfo || {};

    useEffectOnce(() => {
        onImpressionSelfDeliveryInstruction();
    });

    return (
        <>
            <CartGroupContainer className={styles.contentV2}>
                <div className={styles.contentBox}>
                    <h2 className={cx(styles.contentTitle, allowTitleWrap && styles.contentTitleAllowWrap)}>
                        {title}
                    </h2>
                    <p className={styles.contentSubtitle}>{subtitle}</p>
                </div>
                <Image
                    imageUrl={getSelfDeliveryImgURL(imgId)}
                    className={cx(styles.contentImg, allowTitleWrap && styles.contentImgAlignStart)}
                />
            </CartGroupContainer>
        </>
    );
};

export default memo(SelfDeliveryInstruction);
